var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftChevronIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.03,50L77.76,12.74c2.97-2.78,3.12-7.45.33-10.41-2.78-2.97-7.45-3.12-10.41-.33L22.22,44.63c-.06.06-.1.12-.16.18s-.12.1-.18.16c-.12.13-.2.27-.31.4-.16.2-.32.39-.46.6-.13.2-.24.41-.35.62-.11.21-.23.43-.32.65-.09.22-.16.45-.23.68-.07.23-.13.45-.18.68-.05.23-.07.47-.09.7-.02.23-.04.47-.04.7s.02.47.04.7c.02.24.04.47.09.7.04.23.11.45.18.68.07.23.13.46.23.68.09.22.2.43.32.65.11.21.22.42.35.62.14.21.3.4.46.6.11.13.19.28.31.4.05.06.12.1.17.15.06.06.1.13.16.18l45.46,42.63c1.42,1.33,3.23,1.99,5.04,1.99,1.96,0,3.92-.78,5.37-2.33,2.78-2.97,2.63-7.63-.33-10.41l-39.73-37.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevronIcon);
export default __webpack_public_path__ + "static/media/LeftChevronIcon.7b21a9e6673b7a69af9e40cff4a42fdc.svg";
export { ForwardRef as ReactComponent };